// `AuditStamp` — `{ by, at }` (spec/08-api-design.md §3).
//
// Who did it and when. Audit is one of the four places where a quiet mistake costs a venue real
// trust (CLAUDE.md), so the stamp is a shape in the contract rather than two loose fields that
// each module spells differently.
import { z } from "../zod.js";
import { IsoDateTimeSchema } from "./scalars.js";
/**
 * The actor. A TypeID for a person or a device; `null` when the platform itself did it — a job, a
 * lease expiring, a webhook. `null` is deliberate: "the system" is a real answer and writing it as
 * a fake user id is how an audit trail starts lying.
 */
export const ActorRefSchema = z
    .string()
    .regex(/^[a-z][a-z_]*_[0-7][0123456789abcdefghjkmnpqrstvwxyz]{25}$/, 'Expected a TypeID')
    .nullable()
    .openapi('ActorRef', { description: 'The TypeID of whoever acted, or null when the platform did.' });
export const AuditStampSchema = z
    .object({
    by: ActorRefSchema,
    at: IsoDateTimeSchema,
})
    .openapi('AuditStamp', { description: 'Who changed something and when.' });
//# sourceMappingURL=audit-stamp.js.map